import React, { Component } from 'react';
import { Spring } from 'react-spring';
import { history } from '../../helpers/history';
import { constants } from '../../Constants';
import Footer from '../Footer/footer';
import { accountVerify } from '../../helpers/ConstantID';
import defaultImage from '../../static/images/default_BG.png';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class VerificationView extends Component {
	redirectToSignIn() {
		history.replace('/');
	}
	render() {
		const {whitelabel} = this.props;
		return (
			<div className="sh-layout">
				<div className="sh-account-verify-comp">
					<div className="sh-gnrl-inner">
						<div className="sh-gnrl-logo">
						<img
							className="logo" id={accountVerify.sh_av_logo}
							src={whitelabel ? whitelabel[0].logo_url : defaultImage}
							alt="SaayaHealth logo"
						/>
						</div>
						<div className="sh-avc-heading">
							<h2 className="sh-avc-h2" id={accountVerify.sh_av_text1}>
							{constants.CONGRATULATION}
							</h2>
							<p className="sh-avc-gnrl-text sh-mb-15" id={accountVerify.sh_av_text2}>
								{constants.ACCOUNT_VERIFIED_TXT}
							</p>
						</div>
						<div className="sh-avc-form">

							<div className="sh-gnrl-row sh-mb-10">
								<button id={accountVerify.sh_av_btn} className="sh-gnrl-btn sh-login-btn" onClick={()=>{this.redirectToSignIn()}}>
									{constants.SIGN_IN}
								</button>
							</div>
							
							<div className="sh-gnrl-row">
								<label htmlFor={accountVerify.sh_av_cs_btn} className="sh-avc-cnslr">
									Need help? <span>Customer support</span>
								</label>
								<button
									className="sh-avc-cnslr-btn"
									onClick={() => {
									console.log("this is button click");
									}}
									id={accountVerify.sh_av_cs_btn}
								></button>
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</div>		
		);
	}
}

function mapStateToProps(state) {
	const { alert } = state;
	const { registering } = state.reg;
	const { whitelabel } = state.whitelabel;
	return {
		alert,
		registering,
		whitelabel,
	};
}

export default withRouter(connect(mapStateToProps)(VerificationView));





// WEBPACK FOOTER //
// ./src/components/Verification/index.js